import "./components/dl-event.js";
import "./components/dl-pageview.js";
import "./components/dl-purchase.js";
import "./components/custom-video.js";
import "./auto-tracking/init/basedata.js";
import "./auto-tracking/listeners/click/index.js";
import "./auto-tracking/listeners/copy/index.js";
import "./auto-tracking/listeners/change/index.js";
import "./auto-tracking/listeners/form/index.js";
import "./auto-tracking/listeners/dialog.js";

// Handler initialisieren
import PageviewHandler from "./auto-tracking/handlers/PageviewHandler.js";
import PurchaseHandler from "./auto-tracking/handlers/PurchaseHandler.js";
import ImpressionHandler from "./auto-tracking/handlers/ImpressionHandler.js";
import { registerPromotionTracker } from "./auto-tracking/handlers/promotion-tracker-registry.js";

let pageviewHandler = null;
let purchaseHandler = null;
let productTracker = null;
let promotionTracker = null;

/**
 * Initialisiert alle Tracking-Handler
 */
function initHandlers() {
    // Pageview und Purchase Handler
    pageviewHandler = new PageviewHandler();
    purchaseHandler = new PurchaseHandler();

    pageviewHandler.init();
    purchaseHandler.init();

    // Impression Tracker für Produkte und Promotions
    productTracker = new ImpressionHandler('item', 25);
    promotionTracker = new ImpressionHandler('promotion', 25);

    registerPromotionTracker(promotionTracker);

    productTracker.init();
    promotionTracker.init();
}

/**
 * Verbleibende Impressions in den Data Layer flushen.
 *
 * Wird bei visibilitychange ('hidden') und pagehide aufgerufen.
 * processRemainingEntries ist idempotent (no-op bei leerer Queue), daher
 * unschädlich, wenn beide Events kurz hintereinander feuern.
 *
 * Bewusst kein destroy(): nach 'hidden' oder 'pagehide' (persisted=true) kann
 * die Seite aus dem bfcache zurückkommen, dann müssen die Observer weiterlaufen.
 */
function flushImpressions() {
    productTracker?.processRemainingEntries();
    promotionTracker?.processRemainingEntries();
}

function handleVisibilityChange() {
    if (document.visibilityState === 'hidden') {
        flushImpressions();
    }
}

initHandlers();

// visibilitychange + pagehide statt beforeunload:
// beforeunload feuert auf Mobile oft nicht und blockiert den bfcache.
document.addEventListener('visibilitychange', handleVisibilityChange);
window.addEventListener('pagehide', flushImpressions);
